import {getMethod, postMethod, putMethod, patchMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/ownPackageContracts', request)
}

async function post(request) {
    return await postMethod('/api/ownPackageContracts', request)
}

async function put(request) {
    return await putMethod('/api/ownPackageContracts', request)
}

async function patch(id, request) {
    return await patchMethod(`/api/ownPackageContracts/${id}`, request)
}

export {get, post, put, patch}
